/** @jsxImportSource @emotion/react */
import React, { FC } from 'react';

import poweredByStyles from './powered-by.styles';
import applePay from '../../../../assets/apple-pay.svg';
import visa from '../../../../assets/visa.svg';
import mastercard from '../../../../assets/mastercard.svg';
import googlePay from '../../../../assets/google-pay.svg';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';

const PAYMENTS_PLATFORM_LIST = [
    { src: visa, alt: 'Visa' },
    { src: mastercard, alt: 'Mastercard' },
    { src: applePay, alt: 'Apple pay' },
    { src: googlePay, alt: 'Google pay' },
];

export const PoweredBy: FC = () => {
    const intl = useIntl();
    return (
        <div css={poweredByStyles.poweredBy}>
            <div css={poweredByStyles.poweredByText}>{intl.formatMessage({ id: 'grizzleConnectByUnitedChargers' })}</div>
            <div css={poweredByStyles.poweredByText}>
                {intl.formatMessage({ id: 'byUsingOurWebsite' })}
            </div>
            <div css={poweredByStyles.linksBox}>
                <Link to="/terms-of-offer" css={poweredByStyles.link}>{intl.formatMessage({ id: 'termsOfOffer.title' })}</Link>
                <Link to="/privacy-policy" css={poweredByStyles.link}>{intl.formatMessage({ id: 'privacyPolicy.title' })}</Link>
            </div>
            <div css={poweredByStyles.paymentsListContainer}>
                {PAYMENTS_PLATFORM_LIST.map(({ src, alt }) => (
                    <img src={src} alt={alt} key={alt} />
                ))}
            </div>
        </div>
    );
};
